// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"69fedd0c","594":"21e7eb67","648":"56c8055e","943":"cbd20d80"}[chunkId] + ".chunk.js";
};